import React, { useState } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import { Flex, Button, Checkbox } from "@fluentui/react-northstar";
import { AxiosError } from "axios";
import { useApp } from "../../contexts/appContext";
import styles from "./commonModal.module.scss";
import InputWithLabel from "../common/inputWithLabel";
import { stringToNumber } from "../../common/numberOperations";
import { hasValue } from "../../common/textOperations";
import Alert from "../common/alert";
import { useAuth } from "../../contexts/authContext";
import { completeTask, createReport } from "../../services/dataService";
import { addHours, setTimeInDate } from "../../common/dateOperations";
import IReport from "../../interfaces/IReport";

const ConfirmCompleteTask = () => {
  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");
  const projectId = params.get("projectId");
  const [subject, setSubject] = useState("");
  const [hours, setHours] = useState("0,5");
  const [createReportForTask, setCreateReportForTask] = useState(false);
  const { state: appState, dispatch } = useApp();
  const { state: authState } = useAuth();
  const { accessToken: token } = authState;
  const { isDarkTheme } = appState;

  const toggleLoading = (loading: boolean) => {
    dispatch({ type: "SET_LOADER", show: loading });
  };

  const asyncCall = async (callback: any) => {
    toggleLoading(true);
    try {
      await callback;
      toggleLoading(false);
    } catch (error) {
      const err: AxiosError = error as AxiosError;
      toggleLoading(false);
      if (err.response?.status === 401) {
      } else {
        console.log(err.response?.data);
      }
    }
  }

  const complete = async () => {
    if (!token || !id) { return; }
    await asyncCall(completeTask(token, id));
  }

  const addReport = async () => {
    if (!token || !id || !projectId) { return; }

    const startDate = setTimeInDate(new Date(), "09:00");

    const data: IReport = {
      id: "",
      subject: subject,
      start: startDate,
      end: addHours(startDate, stringToNumber(hours)),
      durationInMinutes: stringToNumber(hours) * 60,
      project: {
        id: projectId ?? "",
        customerId: "",
        number: "",
        owner: { login: "", viewOnlyOwnReports: false },
        parentIsClosed: false,
        plannedHours: 0,
        remainingHours: 0,
        reportedHours: 0,
        subject: ""
      },
      overhead: false,
      requestedByCustomer: false,
      overtime: false,
      shadowing: false,
      extendedHours: false,
      carpool: false,
      state: 1,
      description: "",
      kilometers: 0,
      location: "",
      link: "",
    };

    await createReport(token, data);
  };

  const confirmDialog = async () => {
    if (createReportForTask) {
      await asyncCall(addReport());
    }
    await complete();

    microsoftTeams.dialog.url.submit();
  }

  const formIsValid = () => {
    if (createReportForTask) {
      return hasValue(subject) && !isNaN(stringToNumber(hours));
    }

    return true;
  };

  return (
    <Flex gap="gap.medium" column className={styles.container} style={{ backgroundColor: isDarkTheme ? "#292929" : "#FFFFFF" }}>
      <Flex column gap="gap.small">
        {createReportForTask &&
          <>
            <InputWithLabel
              label="Popis výkazu"
              value={subject}
              onChange={(_: any, data: any) => setSubject(data.value)}
            />

            <InputWithLabel
              label="Celková práce v hodinách"
              value={hours}
              onChange={(_: any, data: any) => setHours(data.value)}
            />

            <Alert type="info">Výkaz bude vytvořen na dnes od 9:00</Alert>
          </>
        }

        <Checkbox
          label="Chci zadat výkaz"
          defaultChecked={createReportForTask}
          onChange={(_: any, data: any) => setCreateReportForTask(data.checked)}
        />
      </Flex>

      <Flex>
        <Flex fill></Flex>
        <Flex gap="gap.medium">
          <Button content="Zrušit" onClick={() => microsoftTeams.dialog.url.submit()} disabled={appState.showLoader} />
          <Button content="Dokončit" primary onClick={confirmDialog} loading={appState.showLoader} disabled={!formIsValid() || appState.showLoader} />
        </Flex>
      </Flex>

    </Flex>
  );
};

export default ConfirmCompleteTask;
